import { InputAppearance, TextArea } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';

export interface TextAreaFieldRules {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
}

export interface TextAreaFieldProps {
  name: string;
  label: string;
  rows?: number;
  rules?: TextAreaFieldRules;
  placeholder?: string;
  appearance?: InputAppearance;
  isFloating?: boolean;
  inputMode?: 'none' | 'search' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal';
}

export function TextAreaField({ name, label, rows, rules, appearance, ...rest }: TextAreaFieldProps): ReactElement {
  const { control } = useFormContext();
  const {
    field: { value, onChange, onBlur },
    fieldState: { error, invalid },
    formState: { isSubmitted },
  } = useController({
    name,
    control,
  });

  const showError = isSubmitted && invalid;
  const errorMessage = showError ? error?.message : undefined;
  const appearanceError = showError ? InputAppearance.Error : InputAppearance.Default;

  return (
    <TextArea
      name={name}
      appearance={appearance ?? appearanceError}
      label={label}
      message={errorMessage}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      rows={rows}
      {...rules}
      {...rest}
    />
  );
}
